import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrLightBulbIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M8.0516 0C4.76038 0 2 2.73684 2 6C2 8 3.06168 9.89474 4.54804 10.9474V11.8947C4.54804 12.8421 5.39739 13.6842 6.35291 13.6842H9.85646C10.812 13.6842 11.6613 12.8421 11.6613 11.8947V10.8421C13.0415 9.78947 13.997 8 13.997 6.10526C14.1032 2.73684 11.3428 0 8.0516 0ZM10.5996 9.78947C10.3873 9.89474 10.2811 10.1053 10.2811 10.4211V11.8947C10.2811 12.1053 10.175 12.2105 9.96263 12.2105H6.45907C6.24674 12.2105 6.14057 12.1053 6.14057 11.8947V10.6316C6.14057 10.4211 6.0344 10.1053 5.82206 10C4.33571 9.1579 3.48636 7.68421 3.48636 6C3.48636 3.47368 5.50356 1.47368 8.0516 1.47368C10.5996 1.47368 12.6168 3.47368 12.6168 6C12.6168 7.57895 11.8737 8.94737 10.5996 9.78947ZM11.1305 15.2632C11.1305 15.6842 10.812 16 10.3873 16H5.7159C5.29122 16 4.97272 15.6842 4.97272 15.2632C4.97272 14.8421 5.29122 14.5263 5.7159 14.5263H10.3873C10.812 14.5263 11.1305 14.8421 11.1305 15.2632ZM11.7675 5.36842C11.7675 5.78947 11.449 6.10526 11.0243 6.10526C10.5996 6.10526 10.2811 5.78947 10.2811 5.36842C10.2811 4.52632 9.53796 3.78947 8.68861 3.78947C8.26394 3.78947 7.94543 3.47368 7.94543 3.05263C7.94543 2.63158 8.26394 2.31579 8.68861 2.31579C10.3873 2.31579 11.7675 3.68421 11.7675 5.36842Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrLightBulbIconComponent;
